var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSource(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48ZM32.6619 15.5427C33.0464 15.4203 33.3986 15.2917 33.7171 15.1587C32.3186 13.8188 28.4962 12.8571 24 12.8571C19.5038 12.8571 15.6813 13.8188 14.2829 15.1587C14.6014 15.2917 14.9534 15.4203 15.338 15.5427C17.5212 16.2373 20.5837 16.679 23.9999 16.679C27.4161 16.679 30.4787 16.2373 32.6619 15.5427ZM34.2857 23.9903V16.5468C33.9199 16.6992 33.5287 16.841 33.1167 16.9721C30.7499 17.7251 27.5268 18.179 23.9999 18.179C20.4731 18.179 17.2499 17.7251 14.8832 16.9721C14.4712 16.841 14.08 16.6992 13.7143 16.5469V23.9904C14.1668 24.2533 14.7142 24.5054 15.3518 24.7376C17.5193 25.527 20.5711 26.0295 23.9999 26.0295C27.4287 26.0295 30.4805 25.527 32.648 24.7376C33.2857 24.5054 33.8332 24.2532 34.2857 23.9903ZM13.7143 32.2853V25.6813C14.0668 25.8477 14.4429 26.003 14.8385 26.1471C17.2107 27.011 20.4446 27.5295 23.9999 27.5295C27.5553 27.5295 30.7892 27.011 33.1613 26.1471C33.557 26.003 33.9331 25.8477 34.2857 25.6813V32.2853C34.2857 34.1824 29.7143 35.7138 24 35.7138C18.2857 35.7138 13.7143 34.1824 13.7143 32.2853Z",
    fill: "#C9CCD3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSource);
export default __webpack_public_path__ + "static/media/source.c0df6fcc4aa118493f26bd0ab86a9c57.svg";
export { ForwardRef as ReactComponent };